import ContributionGroupForm from './ContributionGroupForm';
import { Country, State } from '../../forms/address/types';
import type { Contribution } from './ContributionGroupForm';
import AnalyticsService from '../../analytics/AnalyticsService';
import { IViewItemAnalytics } from '../../analytics/types';

interface PageConfig {
  contributionTypes: Array<Contribution>;
  addedContributionId: string | null;
  addedContributionAmount: string | null;
  stateFilterData: { states: State[]; countries: Country[]; };
  viewItemAnalyticsMap: Record<string, IViewItemAnalytics>;
}

window.tnew.page.initialize = ({
  contributionTypes, addedContributionId, addedContributionAmount, stateFilterData, viewItemAnalyticsMap,
}: PageConfig) => {
  const form = new ContributionGroupForm(contributionTypes, stateFilterData, addedContributionId, addedContributionAmount, viewItemAnalyticsMap);

  if (addedContributionId) {
    form.loadContribution(addedContributionId);
  }
};
